import { render } from "./HigherEducationPostDegree.vue?vue&type=template&id=5702f64c"
import script from "./HigherEducationPostDegree.vue?vue&type=script&lang=js"
export * from "./HigherEducationPostDegree.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__